module.exports = __webpack_public_path__ + "img/atletico-madrid.39d7e3b3.png";